import { Component, OnInit, Input } from '@angular/core'
import { ValidatedRadioButtonModel } from '../../../../../validations/validated-radio-button-group.component'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../../../portalglobals'
import * as moment from 'moment'
import { CurrentUserGateway } from '../../../../../common/gateways/current-user-gateway'
@Component({
    selector: 'PhoneEnrollmentExtStep5',
    templateUrl: 'phone-enrollment-step5.component.html',
    styleUrls: ['../phone-enrollment.component.scss']
})
export class PhoneEnrollmentExtStep5Component implements OnInit {
    public rblAgreement: ValidatedRadioButtonModel[] = []
    public rblValidInfo: ValidatedRadioButtonModel[] = []
    public rblTerm: ValidatedRadioButtonModel[] = []
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    public IsRblAgreementNo: boolean
    public IsRblAgreementYes: boolean
    public IsRblValidInfoNo: boolean
    public IsRblValidInfoYes: boolean
    public CurrentDate: string
    public BenefName: string
    public agentName: string
    public planName: string
    showHover: boolean = false
    insuranceComapny: string
    spnIsBeneficiary: string
    spnhimher: string
    checkPlanyear: boolean = false
    ShowCurrentYearScript: boolean = false
    showQtip: boolean = false
    public IsRblTermYes: boolean
    public IsRblTermNo: boolean
    constructor(
        private _enrollementGateway: EnrollmentGateway,
        public _global: PortalGlobals,
        private router: Router,
        private _currentUserGateway: CurrentUserGateway
    ) {
        this.rblAgreement.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblValidInfo.push({ value: 'True', htmlLabel: 'True' }, { value: 'False', htmlLabel: 'False' })
        this.rblTerm.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.IsRblAgreementYes = false
        this.IsRblAgreementNo = false
        this.IsRblValidInfoYes = false
        this.IsRblValidInfoNo = false
        this.IsRblTermYes = false
        this.IsRblTermNo = false
    }
    ngOnInit() {
        if (this._global === undefined || this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    this.insuranceComapny = this._global.currentUser.insuranceCompanyName
                }
            })
        }
        if (this._global.currentUser !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        if (Number(this._global.selectedPlanYear) === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true
        }

        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        this.BenefName = this.enrollmentViewModel.APPFN + ' ' + this.enrollmentViewModel.APPLN
        this.agentName = this._global.currentUser.firstName // + ' ' + this._global.currentUser.lastName
        // this.agentName = this.enrollmentViewModel.AGENTNAME
        this.planName = this.enrollmentViewModel.PLANTYPENAME
        if (this.enrollmentViewModel.PLANYEAR === '2019') {
            this.checkPlanyear = true
        } else {
            this.checkPlanyear = false
        }
        this.setScript()
        this.CurrentDate = moment().format('MM/DD/YYYY')

        this.ShowOptionsRblAgreement(this.enrollmentViewModel.RBLAGREEMENT)
        //this.ShowOptionsRblValidInfo(this.enrollmentViewModel.RBLVALIDINFO)
        this.ShowOptionsRblTerm(this.enrollmentViewModel.RBLVALIDINFO)
    }
    ShowOptionsRblTerm(isgroup: string) {
        if (isgroup === 'Yes') {
            this.IsRblTermYes = true
            this.IsRblTermNo = false
            if (this.enrollmentViewModel.RBLBENFE === 'Yes') {
                this.IsRblTermYes = false
                this.IsRblValidInfoYes = true
            }
        }
        if (isgroup === 'No') {
            this.IsRblTermYes = false
            this.IsRblTermNo = true
            this.IsRblValidInfoYes = false
            //if (!this.ShowCurrentYearScript) {
            this.enrollmentViewModel.RBLAGREEMENT = ''
            this.IsRblAgreementNo = false
            //}
        }
        this.enrollmentViewModel.RBLVALIDINFO = isgroup
    }
    ShowOptionsRblAgreement(isgroup: string) {
        if (isgroup === 'Yes') {
            this.IsRblAgreementYes = true
            this.IsRblAgreementNo = false
            this.IsRblValidInfoYes = true
        }
        if (isgroup === 'No') {
            this.IsRblAgreementYes = false
            this.IsRblAgreementNo = true
            this.IsRblValidInfoYes = false
        }
        this.enrollmentViewModel.RBLAGREEMENT = isgroup
    }
    ShowOptionsRblValidInfo(isgroup: string) {
        if (isgroup === 'True') {
            this.IsRblValidInfoYes = true
            this.IsRblValidInfoNo = false
        }
        if (isgroup === 'False') {
            this.IsRblValidInfoYes = false
            this.IsRblValidInfoNo = true
        }
        this.enrollmentViewModel.RBLVALIDINFO = isgroup
    }
    toggleImage() {
        this.showHover = !this.showHover
    }
    onBack(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Step4'])
    }
    formSubmit(): void {
        this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollmentViewModel.STEPCODE = '5'
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/ext/Preview'])
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
    setScript() {
        this.spnhimher = '(him, her)'
        if (this.enrollmentViewModel.RBLBENFE === 'Yes') {
            this.spnIsBeneficiary = 'your'
        }
        if (this.enrollmentViewModel.RBLBENFE === 'No' && this.BenefName !== ' ' && this.BenefName !== 'undefined undefined') {
            this.spnIsBeneficiary = this.BenefName + '’s'
        }
        if (this.enrollmentViewModel.RBLBENFE === 'No' && (this.BenefName === ' ' || this.BenefName === 'undefined undefined')) {
            this.spnIsBeneficiary = '(your, enrollee’s name)'
        }
        if (this.enrollmentViewModel.APPGEN === 'F') {
            this.spnhimher = 'her'
        }
        if (this.enrollmentViewModel.APPGEN === 'M') {
            this.spnhimher = 'him'
        }
    }
}
